import { render } from "./gestoreAllegati.vue?vue&type=template&id=82eeabba&scoped=true&ts=true"
import script from "./gestoreAllegati.vue?vue&type=script&lang=ts"
export * from "./gestoreAllegati.vue?vue&type=script&lang=ts"

import "./gestoreAllegati.vue?vue&type=style&index=0&id=82eeabba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82eeabba"]])

export default __exports__